/**
 * Created by andrey on 23.09.2025
 */

const CloudStorage = function () {
    this.bus = new ConnectorEventEmitter();

    this.conflict = false;
    this.enabled = true;
};

CloudStorage.prototype.initialize = function (callback) {
    connector.platform.on("changeStatus", () => this.connect());
    connector.social.on("changeStatus", () => this.connect());
    connector.social.on("login", () => this.connect());

    this.localStorage = connector.dataLoader.localStorage;

    if (connector.config.cloudStorage) {
        this.cloudStorage = this.detectPlugin();
    }

    if (this.cloudStorage) {
        connector.dataLoader.localStorage = new CloudStorageProxy(this);
    }

    this.connect(() => {
        this.initialized = true;

        callback();
    });
};

CloudStorage.prototype.detectPlugin = function () {
    const source = connector.info.source;

    const plugins = {
        msstart: typeof MSStartCloudStorage !== "undefined" && MSStartCloudStorage
    };

    const PluginClass = plugins[source];
    if (PluginClass) {
        return new PluginClass();
    }
};

CloudStorage.prototype.connect = function (callback) {
    callback = callback || function () {};

    if (this.connecting || !this.cloudStorage || this.connected) {
        callback();
        return;
    }

    this.connecting = true;

    connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.CONNECT);

    const start = Date.now();

    this.cloudStorage.connect((code) => {
        this.connecting = false;

        if (code !== connector.CODE_SUCCEED) {
            connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.CONNECT_RESULT + code);
            callback();
            return;
        }

        console.log(`cloud storage connected ${Date.now() - start}ms`);

        this.connected = true;

        this.synchronize();

        connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.CONNECT_SUCCESS);

        callback();
    });
};

CloudStorage.prototype.synchronize = function () {
    const userIdLocal = this.localStorage.getItem(SimpleDataLoader.TYPES.USER_ID);
    const userIdCloud = this.cloudStorage.getItem(SimpleDataLoader.TYPES.USER_ID);

    console.log(`user local - ${userIdLocal} cloud - ${userIdCloud}`);

    if (!userIdLocal && !userIdCloud) {
        console.log("cloud - both empty - resolved");
        this.resolve();
        return;
    }
    if (!userIdLocal) {
        console.log("cloud - local empty - resolved");
        this.resolve("cloud");
        return;
    }
    if (!userIdCloud) {
        console.log("cloud empty - resolved");
        this.resolve("local");
        return;
    }

    const isSocialUserId = (userId) => userId && !userId.startsWith("__") && userId !== connector.info.deviceID;

    const isSecondLogin = !connector.info.isNative && !connector.platform.oneOf(connector.MSSTART, connector.WECHAT)
        && isSocialUserId(userIdLocal) && isSocialUserId(userIdCloud) && userIdLocal !== userIdCloud;

    if (isSecondLogin) {
        console.log("cloud - second login - resolved");
        this.resolve("cloud");
        return;
    }

    if (this.isStoragesEquals(this.localStorage, this.cloudStorage)) {
        console.log("cloud - data same - resolved");
        connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.RESOLVE_EQUALS_DATA);
        this.resolve();
        return;
    }

    this.setConflict(true);
};

CloudStorage.prototype.resolve = function (choose = "equals") {
    if (choose === "equals") {
        console.log("local and cloud equals");
    } else if (choose === "local") {
        console.log("cloud - choose local");
        this.copyStorage(this.localStorage, this.cloudStorage);
    } else {
        console.log("choose cloud");
        this.copyStorage(this.cloudStorage, this.localStorage);
    }

    this.setConflict(false);

    connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.RESOLVE + choose);

    if (!this.initialized) {
        connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.RESOLVE_INITIALIZE + choose);
    } else if (choose === "cloud") {
        this.setEnabled(false);
        connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.RESOLVE_DISABLE + choose);
    }
};

CloudStorage.prototype.hasConflict = function () {
    return this.conflict;
};

CloudStorage.prototype.setConflict = function (conflict) {
    if (this.conflict === conflict) {
        return;
    }

    this.conflict = conflict;

    console.log(`cloud conflict - ${conflict}`);

    if (this.conflict) {
        this.bus.trigger("conflict");
        connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.CONFLICT);
    } else {
        connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.CONFLICT_RESOLVED);
    }
};

CloudStorage.prototype.isEnabled = function () {
    return this.enabled;
};

CloudStorage.prototype.setEnabled = function (enabled) {
    if (this.enabled === enabled) {
        return;
    }

    this.enabled = enabled;

    console.log(`cloud enabled - ${enabled}`);

    if (!this.enabled) {
        this.bus.trigger("disable");
    }
};

CloudStorage.prototype.copyStorage = function (from, to) {
    const prefixes = CloudStorage.GetLocalStoragePrefixes();

    const data = {};

    prefixes.forEach((prefix) => {
        Object.assign(data, from.getData(prefix));
    });

    for (const prefix of prefixes) {
        to.clearData(prefix);
    }

    for (const key in data) {
        to.setItem(key, data[key]);
    }

    connector.config.debugMode && console.log("cloud - data copied");
    connector.config.debugMode && console.log("cloud", data);
};

CloudStorage.prototype.isStoragesEquals = function (local, cloud) {
    const prefixes = CloudStorage.GetLocalStoragePrefixes();

    return prefixes.every((prefix) => {
        const data1 = local.getData(prefix);
        const data2 = cloud.getData(prefix);

        connector.config.debugMode && console.log("cloud compare storages", data1, data2);

        const keys1 = Object.keys(data1).sort();
        const keys2 = Object.keys(data2).sort();

        if (keys1.length !== keys2.length) {
            connector.config.debugMode && console.log("cloud not equals keys length", keys1.length, keys2.length);
            return false;
        }

        for (let i = 0; i < keys1.length; i++) {
            if (keys1[i] !== keys2[i]) {
                connector.config.debugMode && console.log("cloud not equals keys", keys1[i], keys2[i]);
                return false;
            }

            if (data1[keys1[i]] !== data2[keys2[i]]) {
                connector.config.debugMode && console.log("cloud not equals data", keys1[i], data1[keys1[i]], data2[keys2[i]]);
                return false;
            }
        }

        return true;
    });
};

CloudStorage.prototype.getLocalStorage = function () {
    return this.localStorage;
};

CloudStorage.prototype.getCloudStorage = function () {
    return this.cloudStorage;
};

CloudStorage.prototype.getItem = function (key) {
    return this.localStorage.getItem(key);
};

CloudStorage.prototype.setItem = function (key, value) {
    if (this.enabled === false) {
        return;
    }

    if (!this.conflict && this.cloudStorage && this.cloudStorage.connected) {
        this.cloudStorage.setItem(key, value);
    }

    this.localStorage.setItem(key, value);
};

CloudStorage.prototype.removeItem = function (key) {
    if (this.enabled === false) {
        return;
    }

    if (!this.conflict && this.cloudStorage && this.cloudStorage.connected) {
        this.cloudStorage.removeItem(key);
    }

    this.localStorage.removeItem(key);
};

CloudStorage.prototype.getData = function (prefix = "") {
    return this.localStorage.getData(prefix);
};

CloudStorage.prototype.clearData = function (prefix = "") {
    if (this.enabled === false) {
        return;
    }

    if (!this.conflict && this.cloudStorage && this.cloudStorage.connected) {
        this.cloudStorage.clearData(prefix);
    }

    this.localStorage.clearData(prefix);
};

CloudStorage.GetLocalStoragePrefixes = function () {
    return [
        SimpleDataLoader.GetLocalStoragePrefix(),
        connector.config.projectId + connector.platform.getPlugin().getLocalStoragePrefix()
    ];
};